import { Icon } from '@iconify/react'
import {
  Box,
  Button,
  Card,
  Grid,
  NativeSelect,
  Stack,
  Typography,
} from '@mui/material'
import { CardImage } from './components/CardImage'
import { CustomButton } from './components/CustomButton'
import { DataType, TCard } from './types'

interface CardSectionProps {
  data: DataType
  setData: React.Dispatch<React.SetStateAction<DataType>>
}

export function CardSection(props: CardSectionProps) {
  const { data, setData } = props

  const handleChange = (field: keyof TCard, index: number, value: any) => {
    setData((data) => ({
      ...data,
      cards: data.cards.map((c, i) =>
        i === index ? { ...c, [field]: value } : c
      ),
    }))
  }

  const handleDelete = (index: number) => {
    setData((data) => ({
      ...data,
      cards: data.cards.filter((_, i) => i !== index),
    }))
  }

  return (
    <Stack>
      <Card
        sx={{
          p: 2,
          mb: 2,
          backgroundColor: 'background.paper',
          display: data.errors.length && data.showErrors ? undefined : 'none',
        }}
      >
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body1" fontWeight={700} color="error.main">
            The following cards could not be identified:
          </Typography>
          <Button
            onClick={() => setData((data) => ({ ...data, showErrors: false }))}
            sx={{ height: 30, width: 40, minWidth: 40 }}
          >
            X
          </Button>
        </Stack>
        <Stack spacing={0.5} sx={{ pt: 1 }}>
          {data.errors.map((error, index) => (
            <Typography variant="body2" key={index}>{`• ${error}`}</Typography>
          ))}
        </Stack>
      </Card>
      <Box>
        <Grid container spacing={2} sx={{ width: '100%' }}>
          {data.cards.map((card, index) => (
            <Grid item xs={6} sm={4} lg={3} key={index}>
              <Stack spacing={0.5}>
                <CardImage url={card.selectedURL} quantity={card.quantity} />
                <Box>
                  <Grid spacing={0.25} container>
                    <Grid item xs={4}>
                      <CustomButton
                        onClick={() =>
                          handleChange('quantity', index, card.quantity - 1)
                        }
                        disabled={card.quantity === 1}
                      >
                        <Icon icon="mdi:minus" />
                      </CustomButton>
                    </Grid>
                    <Grid item xs={4}>
                      <CustomButton
                        onClick={() =>
                          handleChange('quantity', index, card.quantity + 1)
                        }
                      >
                        <Icon icon="mdi:plus" />
                      </CustomButton>
                    </Grid>
                    <Grid item xs={4}>
                      <CustomButton onClick={() => handleDelete(index)}>
                        <Icon icon="mdi:trash-can-outline" />
                      </CustomButton>
                    </Grid>
                  </Grid>
                </Box>
                <NativeSelect
                  value={card.selectedURL}
                  onChange={(e) =>
                    setData((data) => ({
                      ...data,
                      cards: data.cards.map((c, i) =>
                        i === index ? { ...c, selectedURL: e.target.value } : c
                      ),
                    }))
                  }
                >
                  {card.setOptions.map((setOption, index) => (
                    <option value={setOption.url} key={index}>
                      {setOption.name}
                    </option>
                  ))}
                </NativeSelect>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Stack>
  )
}
